export default __webpack_public_path__ + "static/media/icon-blue.7e9bf446.svg";